import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/app/src/components/analytics/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManager","GoogleTagManagerNoscript"] */ "/app/src/components/analytics/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MicrosoftClarity"] */ "/app/src/components/analytics/MicrosoftClarity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SplashAnimation"] */ "/app/src/components/SplashAnimation.tsx");
